import { Editor } from 'roosterjs-editor-core';
import { PluginEvent, PluginDomEvent, PluginEventType } from 'roosterjs-editor-types';

export default function atMentionsPluginTrigger(evt: PluginEvent, editor: Editor) {
    if (evt.eventType === PluginEventType.KeyPress) {
        const keyboardEvent = (evt as PluginDomEvent).rawEvent as KeyboardEvent;
        return keyboardEvent.key == '@' || (keyboardEvent.key == '2' && keyboardEvent.shiftKey);
    }
    return false;
}
